import { ILogger, LogLevel, LogOptions } from '../../types';

// NOTE: Currently not used.
export class SentryLogger implements ILogger {
  private inited = false;

  init(appName: string, environment: string): void {
    if (this.inited) return;
    this.inited = true;

    // Sentry.init({
    //   dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    //   environment,
    //   release: appName,
    // });
  }

  log(level: LogLevel, message: string, options?: LogOptions): void {
    if (!this.inited) return;

    const { data, error, metadata } = options ?? {};

    // NOTE: Integrate with Sentry/other provider here.
    // This file intentionally stays dumb in this template.
    switch (level) {
      case 'info': {
        // Sentry.captureMessage(message, {
        //   level: 'info',
        //   extra: { data, metadata },
        // });
        break;
      }
      case 'warn': {
        // Sentry.captureMessage(message, {
        //   level: 'warning',
        //   extra: { data, metadata },
        // });
        break;
      }
      case 'error': {
        // Sentry.captureException(
        //   error instanceof Error ? error : new Error(message),
        //   { extra: { data, metadata } },
        // );
        break;
      }
      default:
        break;
    }
  }
}

export const sentryLogger = new SentryLogger();
